import { render, staticRenderFns } from "./DistSelectPostazione.vue?vue&type=template&id=5c2c24d6"
import script from "./DistSelectPostazione.vue?vue&type=script&lang=js"
export * from "./DistSelectPostazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports